<template>
    <sections>
        <app-subheader title="Post" :parent="{title: 'Blog', route: '/blog'}"></app-subheader>
        <section-title
            padding="py-6 sm:py-10"
            imageAspectRatio="aspect-video"
            :image="postImage"
            :heading="postHeading"
            :content="postContent"
        ></section-title>
    </sections>
</template>

<script setup>
const $config = useRuntimeConfig();

const postImage = ref($config.public.images + 'west-coast-3.jpg');
const postHeading = ref('What to Expect at Your First Class');
const postContent = ref('<article-blog-expect />');
const postExcerpt = ref("Here's how our introductory classes go down.");

useSeo().buildHead({
    image: postImage.value,
    title: postHeading.value + ' | ' + $config.public.siteName,
    description: postExcerpt.value,
    index: true,
});
</script>
